import { useQuery } from "@apollo/client";
import { TextField } from "@material-ui/core";
import { MenuItem } from "@material-ui/core";
import { FETCH_ENTITIES } from "../graphql/queries";

export default function SelectEntities({ value, onChange, style }) {
  const { data, loading } = useQuery(FETCH_ENTITIES, {
    variables: {
      all: true,
    },
  });

  return (
    <TextField
      select
      value={loading ? 1 : value}
      disabled={loading}
      label="Entidades"
      onChange={(e) => onChange(e.target.value)}
      variant="outlined"
      fullWidth
    >
      {loading && <MenuItem value={1}>Carregando..</MenuItem>}

      {data &&
        data.fetchEntities.data.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
    </TextField>
  );
}
